module.exports = __webpack_public_path__ + "img/qihui_home_image_cutoutqrcode@2x.e49f6438.png";